/**
 * クライアントサイドで使用
 * =============================================
 */

// sass 読み込み
import "../sass/index.scss"

// jquery プラグインの登録
import 'slick-carousel'
import 'jquery.easing'

// module 読み込み
import "./modules/header-humberger.js"
import "./modules/header-search.js"
import "./modules/header-fixed.js"
import "./modules/post-index.js"
import "./modules/scroll.js"
import "./modules/front-pickups.js"
import "./modules/single-recruit-relative.js"
import "./modules/barba-init.js"
